import '../../../public-path';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import { createRoot } from 'react-dom/client';
import StandardPageWrapper from '../../../components/main-wrappers/StandardPageWrapper';
import { OneLPSsdkParamsContext, sdkParams } from '../../../onelps-sdk-params-context';
import conceptConfig from '../../../../concept-configs/placeholder.json';
import '../../../css/vars/foe/standard-belowthefold/vars.css';
import '../../../css/global.css';
import Store from '../../../Store';
import { InitialiseMetrics } from '../../../metrics-config';
import HeadTags from '../../../components/common/HeadTags';
import Hero from '../../../components/main-wrappers/hero/Hero';
import '../../../css/components/fontFaceDefinitions/fontFacesFoeStellarAge.css';
import BelowTheFoldWrapper from '../../../components/main-wrappers/foe/BelowTheFoldWrapperFoe';

import reloadIfRestoredFromBfCache from '../../../helpers/bfcache';
import OnelpsChallengeSolver from '../../../components/common/OnelpsChallengeSolver';

reloadIfRestoredFromBfCache();

InitialiseMetrics(sdkParams);

const container = document.getElementById('app');
const root = createRoot(container);

root.render(
	<Store>
		<OneLPSsdkParamsContext.Provider value={{ ...sdkParams, ...conceptConfig }}>
			<HeadTags />
			<Hero />
			<StandardPageWrapper showFooter={false} />
			<BelowTheFoldWrapper />
			<OnelpsChallengeSolver />
		</OneLPSsdkParamsContext.Provider>
	</Store>
);
